import { useEffect, useMemo, useState } from 'react'
import { supabase } from '@/lib/supabase'

type TF = 'D' | 'W' | 'M' | '720' | '240' | '60' | null

function tfToLabel(tf: TF): string | null {
  if (!tf) return null
  switch (tf) {
    case 'D': return 'Diário'
    case 'W': return 'Semanal'
    case 'M': return 'Mensal'
    case '60': return '1h'
    case '240': return '4h'
    case '720': return '12h'
    default: return null
  }
}

export function useBTCHigherTFWarning(pollMs: number = 30000) {
  const [tf, setTf] = useState<TF>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  async function fetchDominant() {
    setError(null)
    setLoading(true)
    try {
      const { data, error } = await (supabase as any).rpc('resolve_warning_tf', { p_symbol: 'BTCUSDT' })
      if (error) throw new Error(error.message || 'Falha ao consultar dominância')
      const tfVal = (data as string | null) as TF
      setTf(tfVal)
    } catch (e: any) {
      setError(e?.message || 'Erro ao consultar mandante do BTC')
      setTf(null)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDominant()
    if (pollMs && pollMs > 0) {
      const id = setInterval(fetchDominant, pollMs)
      return () => clearInterval(id)
    }
    return
  }, [pollMs])

  const show = useMemo(() => tf === 'D' || tf === 'W' || tf === 'M', [tf])
  const label = useMemo(() => tfToLabel(tf as TF), [tf])

  return { show, label, timeframe: tf, loading, error }
}
